import {ListConfigs} from '../../sharedComponent/SearchList/SearchList.types'

export const ACTIVITYLISTCONFIGS: ListConfigs[] = [
  {
    headerName: 'Role',
    apiFieldName: 'role',
    columnWidth: '150',
    type: 'TEXT',
  },
  {
    headerName: 'Date / Time',
    apiFieldName: 'timeChanged',
    columnWidth: '150',
    type: 'LOCALTIME',
  },
  {
    headerName: 'Updated By',
    apiFieldName: 'updatedBy',
    columnWidth: '150',
    type: 'TEXT',
  },
]


